import Vue from 'vue';
import Vuex from 'vuex';
import admin from '@/store/modules/admin';
import auth from '@/store/modules/auth';
import darkSwitcher from '@/store/modules/darkSwitcher';
import customer from '@/store/modules/customer';
import sideMenu from '@/store/modules/sideMenu';
import report from '@/store/modules/report';
import file from '@/store/modules/file';
import loan from '@/store/modules/loan';
import officer from '@/store/modules/officer';
import other from '@/store/modules/other';
import journal from '@/store/modules/journal';
import note from '@/store/modules/note';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    admin,
    auth,
    darkSwitcher,
    customer,
    sideMenu,
    report,
    file,
    loan,
    officer,
    other,
    journal,
    note,
  },
  strict: debug,
});
